import React, { memo } from 'react';

import { setTimeStamp } from '../../../../../../includes/util';

interface IProps {
  item: any,
  isActive: boolean,
  clickedVehicle: (item: any) => void
}

const VehicleHistoryItemGrid: React.FC<IProps> = ({ item, isActive, clickedVehicle }) => {


  const onClickedVehicle = () => {
    clickedVehicle(item);
  };

  return (
    <div className={`row no-gutters history-item ${isActive ? "active" : ""}`} onClick={onClickedVehicle}>
      <div className="col-4">
        {setTimeStamp(item.OdometerReadingTimestamp)}
      </div>
      <div className="col">
        {item.Odometer}
      </div>
      <div className="col">
        {item.LocationDescription}
      </div>

    </div>
  );
};

export default memo(VehicleHistoryItemGrid);